// Kecamatan and Desa options
export const kecamatanDesa = {
  "Taliwang": ["Menala", "Dalam", "Sampir", "Kuang", "Bugis", "Arab Kenangan", "Telaga Bertong", "Tamekan", "Seloto", "Lamunga", "Batu Putih", "Banjar", "Sermong", "Labuhan Kertasari", "Labuhan Lalar", "Lalar Liang"],
  "Seteluk": ["Seteluk Tengah", "Seteluk Atas", "Seran", "Rempe", "Tapir", "Air Suning", "Kelanir", "Lamusung", "Desa Loka", "Meraran"],
  "Poto Tano": ["Poto Tano", "Kokarlian", "Tambak Sari", "Tebo", "Senayan", "Kiantar", "Tuananga", "Mantar"],
  "Brang Rea": ["Lamuntet", "Rarak Ronges", "Bangkat Monteh", "Moteng", "Tepas Sepakat", "Tepas", "Sapugara Bree", "Seminar Salit", "Desa Beru"],
  "Brang Ene": ["Lampok", "Mujahidin", "Kalimantong", "Manemeng", "Mataiyang", "Mura"],
  "Jereweh": ["Dasan Anyar", "Goa", "Beru", "Belo"],
  "Maluk": ["Benete", "Bukit Damai", "Mantun", "Pasir Putih", "Maluk"],
  "Sekongkang": ["Talonang Baru", "Tatar", "Ai Kangkung", "Sekongkang Atas", "Tongo", "Kemuning", "Sekongkang Bawah"],
};

// Form field options
export const formOptions = {
  statusRumah: [
    { value: "Tidak Berpenghuni", label: "Tidak Berpenghuni" },
    { value: "Berpenghuni", label: "Berpenghuni" }
  ],
  
  jenisKelamin: [
    { value: "Laki-laki", label: "Laki-laki" },
    { value: "Perempuan", label: "Perempuan" }
  ],
  
  asalKTP: [
    { value: "KSB", label: "KSB" },
    { value: "Luar KSB", label: "Luar KSB" }
  ],
  
  pendidikanTerakhir: [
    { value: "Tidak Punya Ijazah", label: "Tidak Punya Ijazah" },
    { value: "SD/Sederajat", label: "SD/Sederajat" },
    { value: "SMP/Sederajat", label: "SMP/Sederajat" },
    { value: "SMA/Sederajat", label: "SMA/Sederajat" },
    { value: "D1", label: "D1" },
    { value: "D2", label: "D2" },
    { value: "D3", label: "D3" },
    { value: "D4/S1", label: "D4/S1" },
    { value: "S2", label: "S2" },
    { value: "S3", label: "S3" }
  ],
  
  pekerjaan: [
    { value: "Tidak Bekerja", label: "Tidak Bekerja" },
    { value: "Pensiunan", label: "Pensiunan" },
    { value: "Karyawan BUMN", label: "Karyawan BUMN" },
    { value: "Wirausaha", label: "Wirausaha" },
    { value: "Petani/Pekebun", label: "Petani/Pekebun" },
    { value: "Nelayan", label: "Nelayan" },
    { value: "Pedagang", label: "Pedagang" },
    { value: "Karyawan Swasta", label: "Karyawan Swasta" },
    { value: "Tukang/Montir", label: "Tukang/Montir" },
    { value: "Buruh Harian", label: "Buruh Harian" },
    { value: "Honorer", label: "Honorer" },
    { value: "TNI/POLRI", label: "TNI/POLRI" },
    { value: "ASN", label: "ASN" },
    { value: "Kepala Desa", label: "Kepala Desa" },
    { value: "Perangkat Desa/Kelurahan", label: "Perangkat Desa" },
    { value: "BPD", label: "BPD" },
    { value: "DPRD", label: "DPRD" },
    { value: "Bupati", label: "Bupati" },
    { value: "Wakil Bupati", label: "Wakil Bupati" },
    { value: "manual", label: "Manual" }
  ],
  
  penghasilan: [
    { value: "4300000", label: "Rp. 4.300.000" },
    { value: "4000000", label: "Rp. 4.000.000" },
    { value: "3700000", label: "Rp. 3.700.000" },
    { value: "3400000", label: "Rp. 3.400.000" },
    { value: "3100000", label: "Rp. 3.100.000" },
    { value: "2800000", label: "Rp. 2.800.000" },
    { value: "2500000", label: "Rp. 2.500.000" },
    { value: "2200000", label: "Rp. 2.200.000" },
    { value: "1800000", label: "Rp. 1.800.000" },
    { value: "1500000", label: "Rp. 1.500.000" },
    { value: "1200000", label: "Rp. 1.200.000" },
    { value: "1000000", label: "Rp. 1.000.000" },
    { value: "900000", label: "Rp. 900.000" },
    { value: "600000", label: "Rp. 600.000" },
    { value: "0", label: "Rp. 0" },
    { value: "manual", label: "Manual" }
  ],
  
  statusKepemilikanRumah: [
    { value: "Milik Sendiri", label: "Milik Sendiri" },
    { value: "Bukan Milik Sendiri", label: "Bukan Milik Sendiri" },
    { value: "Kontrak/Sewa", label: "Kontrak/Sewa" }
  ],
  
  asetRumahDiTempatLain: [
    { value: "Ada", label: "Ada" },
    { value: "Tidak Ada", label: "Tidak Ada" }
  ],
  
  statusKepemilikanTanah: [
    { value: "Milik Sendiri", label: "Milik Sendiri" },
    { value: "Bukan Milik Sendiri", label: "Bukan Milik Sendiri" },
    { value: "Tanah Negara", label: "Tanah Negara" }
  ],
  
  asetTanahDiTempatLain: [
    { value: "Ada", label: "Ada" },
    { value: "Tidak Ada", label: "Tidak Ada" }
  ],
  
  sumberPenerangan: [
    { value: "PLN dengan Meteran", label: "PLN dengan Meteran" },
    { value: "PLN tanpa Meteran", label: "PLN tanpa Meteran" },
    { value: "Listrik Non PLN", label: "Listrik Non PLN" },
    { value: "Bukan Listrik", label: "Bukan Listrik" }
  ],
  
  dayaListrik: [
    { value: "450", label: "450 VA" },
    { value: "900", label: "900 VA" },
    { value: "1300", label: "1300 VA" },
    { value: "2200", label: "2200 VA" },
    { value: "3500", label: "3500 VA" }
  ],
  
  bantuanPerumahan: [
    { value: "Pernah, >5 Tahun", label: "Ya. >5 Tahun" },
    { value: "Pernah, <5 Tahun", label: "Ya. <5 Tahun" },
    { value: "Tidak Pernah", label: "Tidak Pernah" }
  ],
  
  modelRumah: [
    { value: "Permanen", label: "Permanen" },
    { value: "Semi Permanen", label: "Semi Permanen" },
    { value: "Panggung", label: "Panggung" }
  ],
  
  kondisiOptions: [
    { value: "Layak", label: "Layak" },
    { value: "Tidak Layak", label: "Tidak Layak" }
  ],
  
  materialLantaiTerluas: [
    { value: "Marmer/Granit", label: "Marmer/Granit" },
    { value: "Keramik", label: "Keramik" },
    { value: "Rabat", label: "Rabat" },
    { value: "Papan Kayu", label: "Papan Kayu" },
    { value: "Bambu", label: "Bambu" },
    { value: "Tanah", label: "Tanah" },
    { value: "manual", label: "Lainnya" }
  ],
  
  materialDindingTerluas: [
    { value: "Tembok Plesteran", label: "Tembok Plesteran" },
    { value: "Tembok Belum Plesteran", label: "Tembok Belum Plesteran" },
    { value: "Triplek", label: "Triplek" },
    { value: "Kalsiboard", label: "Kalsiboard" },
    { value: "Papan Kayu", label: "Papan Kayu" },
    { value: "Kalsiplank", label: "Kalsiplank" },
    { value: "Spandek", label: "Spandek" },
    { value: "Bedek/Anyaman Bambu", label: "Bedek/Anyaman Bambu" },
    { value: "manual", label: "Lainnya" }
  ],
  
  materialPenutupAtapTerluas: [
    { value: "Genteng Kramik", label: "Genteng Kramik" },
    { value: "Genteng Biasa", label: "Genteng Biasa" },
    { value: "Multiroof", label: "Multiroof" },
    { value: "Spandek", label: "Spandek" },
    { value: "Seng", label: "Seng" },
    { value: "Asbes", label: "Asbes" },
    { value: "Daun-daunan", label: "Daun-daunan" },
    { value: "manual", label: "Lainnya" }
  ],
  
  buanganAirLimbahRumahTangga: [
    { value: "Jaringan Perpipaan", label: "Jaringan Perpipaan" },
    { value: "Diresapkan", label: "Diresapkan" },
    { value: "Buang Bebas", label: "Buang Bebas" }
  ],
  
  saranaPengelolaanLimbahCair: [
    { value: "Berfungsi Baik", label: "Berfungsi Baik" },
    { value: "Tidak Berfungsi", label: "Tidak Berfungsi" },
    { value: "Tidak Tersedia", label: "Tidak Tersedia" }
  ],
  
  pemiliharaanSaranaPengelolaanLimbah: [
    { value: "Terpelihara", label: "Terpelihara" },
    { value: "Tidak Terpelihara", label: "Tidak Terpelihara" }
  ],
  
  jenisTempatPembuanganAirTinja: [
    { value: "Tangki Septik", label: "Tangki Septik" },
    { value: "Kolam/Sawah/Sungai", label: "Kolam/Sawah/Sungai" },
    { value: "Lubang Tanah", label: "Lubang Tanah" },
    { value: "Pantai/Tanah Lapangan/Kebun", label: "Pantai/Tanah Lapangan/Kebun" },
    { value: "IPAL", label: "IPAL" }
  ],
  
  kepemilikanKamarMandiDanJamban: [
    { value: "Sendiri", label: "Sendiri" },
    { value: "Bersama/MCK Komunal", label: "Bersama/MCK Komunal" },
    { value: "Tidak Ada", label: "Tidak Ada" }
  ],
  
  jenisKloset: [
    { value: "Leher Angsa", label: "Leher Angsa" },
    { value: "Cubluk/Cemplung", label: "Cubluk/Cemplung" },
    { value: "Plengsengan", label: "Plengsengan" }
  ],
  
  jenisTangkiSeptik: [
    { value: "Pabrikasi", label: "Pabrikasi" },
    { value: "Konvensional", label: "Konvensional" }
  ],
  
  materialTangkiSeptik: [
    { value: "Fiber", label: "Fiber" },
    { value: "Dinding Beton", label: "Dinding Beton" },
    { value: "Batu Bata", label: "Batu Bata" },
    { value: "Tanah", label: "Tanah" }
  ],
  
  alasTangkiSeptik: [
    { value: "Kedap", label: "Kedap" },
    { value: "Tidak Kedap", label: "Tidak Kedap" }
  ],
  
  lubangPenyedotan: [
    { value: "Ada", label: "Ada" },
    { value: "Tidak Ada", label: "Tidak Ada" }
  ],
  
  posisiTangkiSeptik: [
    { value: "Dalam Rumah", label: "Dalam Rumah" },
    { value: "Luar Rumah", label: "Luar Rumah" }
  ],
  
  jarakTangkiSeptikDenganSumberAir: [
    { value: "9", label: "< 10 meter" },
    { value: "11", label: "> 10 meter" }
  ],
  
  sumberAirMinum: [
    { value: "PDAM", label: "PDAM" },
    { value: "SPAMDES", label: "SPAMDES" },
    { value: "Mata Air", label: "Mata Air" },
    { value: "Air Hujan", label: "Air Hujan" },
    { value: "Sumur/Sumur Bor", label: "Sumur/Sumur Bor" },
    { value: "Air Kemasan/Isi Ulang", label: "Air Kemasan/Isi Ulang" }
  ],
  
  fungsiBangunan: [
    { value: "Rumah Tinggal/Hunian", label: "Rumah Tinggal/Hunian" },
    { value: "Rumah Toko (RUKO)", label: "Rumah Toko (RUKO)" }
  ]
};

export const formOptionsBacklog = {
  statusRumah: [
    { value: "Tidak Berpenghuni", label: "Tidak Berpenghuni" },
    { value: "Berpenghuni", label: "Berpenghuni" }
  ],
  
  jenisKelamin: [
    { value: "Laki-laki", label: "Laki-laki" },
    { value: "Perempuan", label: "Perempuan" }
  ],
  
  asalKTP: [
    { value: "KSB", label: "KSB" },
    { value: "Luar KSB", label: "Luar KSB" }
  ],
  
  pendidikanTerakhir: [
    { value: "Tidak Punya Ijazah", label: "Tidak Punya Ijazah" },
    { value: "SD/Sederajat", label: "SD/Sederajat" },
    { value: "SMP/Sederajat", label: "SMP/Sederajat" },
    { value: "SMA/Sederajat", label: "SMA/Sederajat" },
    { value: "D1", label: "D1" },
    { value: "D2", label: "D2" },
    { value: "D3", label: "D3" },
    { value: "D4/S1", label: "D4/S1" },
    { value: "S2", label: "S2" },
    { value: "S3", label: "S3" }
  ],
  
  pekerjaan: [
    { value: "Tidak Bekerja", label: "Tidak Bekerja" },
    { value: "Pensiunan", label: "Pensiunan" },
    { value: "Karyawan BUMN", label: "Karyawan BUMN" },
    { value: "Wirausaha", label: "Wirausaha" },
    { value: "Petani/Pekebun", label: "Petani/Pekebun" },
    { value: "Nelayan", label: "Nelayan" },
    { value: "Pedagang", label: "Pedagang" },
    { value: "Karyawan Swasta", label: "Karyawan Swasta" },
    { value: "Tukang/Montir", label: "Tukang/Montir" },
    { value: "Buruh Harian", label: "Buruh Harian" },
    { value: "Honorer", label: "Honorer" },
    { value: "TNI/POLRI", label: "TNI/POLRI" },
    { value: "ASN", label: "ASN" },
    { value: "Kepala Desa", label: "Kepala Desa" },
    { value: "Perangkat Desa/Kelurahan", label: "Perangkat Desa" },
    { value: "BPD", label: "BPD" },
    { value: "DPRD", label: "DPRD" },
    { value: "Bupati", label: "Bupati" },
    { value: "Wakil Bupati", label: "Wakil Bupati" },
    { value: "manual", label: "Manual" }
  ],
  
  penghasilan: [
    { value: "4300000", label: "Rp. 4.300.000" },
    { value: "4000000", label: "Rp. 4.000.000" },
    { value: "3700000", label: "Rp. 3.700.000" },
    { value: "3400000", label: "Rp. 3.400.000" },
    { value: "3100000", label: "Rp. 3.100.000" },
    { value: "2800000", label: "Rp. 2.800.000" },
    { value: "2500000", label: "Rp. 2.500.000" },
    { value: "2200000", label: "Rp. 2.200.000" },
    { value: "1800000", label: "Rp. 1.800.000" },
    { value: "1500000", label: "Rp. 1.500.000" },
    { value: "1200000", label: "Rp. 1.200.000" },
    { value: "1000000", label: "Rp. 1.000.000" },
    { value: "900000", label: "Rp. 900.000" },
    { value: "600000", label: "Rp. 600.000" },
    { value: "0", label: "Rp. 0" },
    { value: "manual", label: "Manual" }
  ],
  
  statusKepemilikanRumah: [
    { value: "Milik Sendiri", label: "Milik Sendiri" },
    { value: "Bukan Milik Sendiri", label: "Bukan Milik Sendiri" },
    { value: "Kontrak/Sewa", label: "Kontrak/Sewa" }
  ],
  
  asetRumahDiTempatLain: [
    { value: "Ada", label: "Ada" },
    { value: "Tidak Ada", label: "Tidak Ada" }
  ],
  
  statusKepemilikanTanah: [
    { value: "Milik Sendiri", label: "Milik Sendiri" },
    { value: "Bukan Milik Sendiri", label: "Bukan Milik Sendiri" },
    { value: "Tanah Negara", label: "Tanah Negara" }
  ],
  
  asetTanahDiTempatLain: [
    { value: "Ada", label: "Ada" },
    { value: "Tidak Ada", label: "Tidak Ada" }
  ],
  
  sumberPenerangan: [
    { value: "PLN dengan Meteran", label: "PLN dengan Meteran" },
    { value: "PLN tanpa Meteran", label: "PLN tanpa Meteran" },
    { value: "Listrik Non PLN", label: "Listrik Non PLN" },
    { value: "Bukan Listrik", label: "Bukan Listrik" }
  ],
  
  dayaListrik: [
    { value: "450", label: "450 VA" },
    { value: "900", label: "900 VA" },
    { value: "1300", label: "1300 VA" },
    { value: "2200", label: "2200 VA" },
    { value: "3500", label: "3500 VA" }
  ],
  
  bantuanPerumahan: [
    { value: "Pernah, >5 Tahun", label: "Ya. >5 Tahun" },
    { value: "Pernah, <5 Tahun", label: "Ya. <5 Tahun" },
    { value: "Tidak Pernah", label: "Tidak Pernah" }
  ],
  
  modelRumah: [
    { value: "Permanen", label: "Permanen" },
    { value: "Semi Permanen", label: "Semi Permanen" },
    { value: "Panggung", label: "Panggung" }
  ],
  
  kondisiOptions: [
    { value: "Layak", label: "Layak" },
    { value: "Tidak Layak", label: "Tidak Layak" }
  ],
  
  materialLantaiTerluas: [
    { value: "Marmer/Granit", label: "Marmer/Granit" },
    { value: "Keramik", label: "Keramik" },
    { value: "Rabat", label: "Rabat" },
    { value: "Papan Kayu", label: "Papan Kayu" },
    { value: "Bambu", label: "Bambu" },
    { value: "Tanah", label: "Tanah" },
    { value: "manual", label: "Lainnya" }
  ],
  
  materialDindingTerluas: [
    { value: "Tembok Plesteran", label: "Tembok Plesteran" },
    { value: "Tembok Belum Plesteran", label: "Tembok Belum Plesteran" },
    { value: "Triplek", label: "Triplek" },
    { value: "Kalsiboard", label: "Kalsiboard" },
    { value: "Papan Kayu", label: "Papan Kayu" },
    { value: "Kalsiplank", label: "Kalsiplank" },
    { value: "Spandek", label: "Spandek" },
    { value: "Bedek/Anyaman Bambu", label: "Bedek/Anyaman Bambu" },
    { value: "manual", label: "Lainnya" }
  ],
  
  materialPenutupAtapTerluas: [
    { value: "Genteng Kramik", label: "Genteng Kramik" },
    { value: "Genteng Biasa", label: "Genteng Biasa" },
    { value: "Multiroof", label: "Multiroof" },
    { value: "Spandek", label: "Spandek" },
    { value: "Seng", label: "Seng" },
    { value: "Asbes", label: "Asbes" },
    { value: "Daun-daunan", label: "Daun-daunan" },
    { value: "manual", label: "Lainnya" }
  ],
  
  buanganAirLimbahRumahTangga: [
    { value: "Jaringan Perpipaan", label: "Jaringan Perpipaan" },
    { value: "Diresapkan", label: "Diresapkan" },
    { value: "Buang Bebas", label: "Buang Bebas" }
  ],
  
  saranaPengelolaanLimbahCair: [
    { value: "Berfungsi Baik", label: "Berfungsi Baik" },
    { value: "Tidak Berfungsi", label: "Tidak Berfungsi" },
    { value: "Tidak Tersedia", label: "Tidak Tersedia" }
  ],
  
  pemiliharaanSaranaPengelolaanLimbah: [
    { value: "Terpelihara", label: "Terpelihara" },
    { value: "Tidak Terpelihara", label: "Tidak Terpelihara" }
  ],
  
  jenisTempatPembuanganAirTinja: [
    { value: "Tangki Septik", label: "Tangki Septik" },
    { value: "Kolam/Sawah/Sungai", label: "Kolam/Sawah/Sungai" },
    { value: "Lubang Tanah", label: "Lubang Tanah" },
    { value: "Pantai/Tanah Lapangan/Kebun", label: "Pantai/Tanah Lapangan/Kebun" },
    { value: "IPAL", label: "IPAL" }
  ],
  
  kepemilikanKamarMandiDanJamban: [
    { value: "Sendiri", label: "Sendiri" },
    { value: "Bersama/MCK Komunal", label: "Bersama/MCK Komunal" },
    { value: "Tidak Ada", label: "Tidak Ada" }
  ],
  
  jenisKloset: [
    { value: "Leher Angsa", label: "Leher Angsa" },
    { value: "Cubluk/Cemplung", label: "Cubluk/Cemplung" },
    { value: "Plengsengan", label: "Plengsengan" }
  ],
  
  jenisTangkiSeptik: [
    { value: "Pabrikasi", label: "Pabrikasi" },
    { value: "Konvensional", label: "Konvensional" }
  ],
  
  materialTangkiSeptik: [
    { value: "Fiber", label: "Fiber" },
    { value: "Dinding Beton", label: "Dinding Beton" },
    { value: "Batu Bata", label: "Batu Bata" },
    { value: "Tanah", label: "Tanah" }
  ],
  
  alasTangkiSeptik: [
    { value: "Kedap", label: "Kedap" },
    { value: "Tidak Kedap", label: "Tidak Kedap" }
  ],
  
  lubangPenyedotan: [
    { value: "Ada", label: "Ada" },
    { value: "Tidak Ada", label: "Tidak Ada" }
  ],
  
  posisiTangkiSeptik: [
    { value: "Dalam Rumah", label: "Dalam Rumah" },
    { value: "Luar Rumah", label: "Luar Rumah" }
  ],
  
  jarakTangkiSeptikDenganSumberAir: [
    { value: "9", label: "< 10 meter" },
    { value: "11", label: "> 10 meter" }
  ],
  
  sumberAirMinum: [
    { value: "PDAM", label: "PDAM" },
    { value: "SPAMDES", label: "SPAMDES" },
    { value: "Mata Air", label: "Mata Air" },
    { value: "Air Hujan", label: "Air Hujan" },
    { value: "Sumur/Sumur Bor", label: "Sumur/Sumur Bor" },
    { value: "Air Kemasan/Isi Ulang", label: "Air Kemasan/Isi Ulang" }
  ],
  
  fungsiBangunan: [
    { value: "Rumah Tinggal/Hunian", label: "Rumah Tinggal/Hunian" },
    { value: "Rumah Toko (RUKO)", label: "Rumah Toko (RUKO)" }
  ]
}
// Required coordinate kecamatan
export const requiredCoordinateKecamatan = ["Maluk", "Jereweh"];
